import {BaseContainerModel} from '../../base-container.model';
import { bl_fi_mst_item_event_RowClass } from '../../../dbschema/bl_fi_mst_item_event.model';

export class FinancialItemEventContainerModel extends BaseContainerModel {
  bl_fi_mst_item_event: bl_fi_mst_item_event_RowClass = new bl_fi_mst_item_event_RowClass();
}
